import React, { useEffect, useCallback } from 'react';
import { createSelector } from 'reselect';
import { useSelector, useDispatch } from 'react-redux';
import { defineMessages, FormattedMessage } from 'react-intl';
import get from 'lodash.get';
import { TreeNav } from 'ui-components/components/tree-navigation';
import Global from '../../../../store/global-selectors';
import { SearchForm } from '../../../../components/orders-grid/search-form';
import * as NavActions from '../../../../store/customers/nav/customers.nav.actions';
import { requestGetCustomers } from '../../../../store/customers/customers.actions';
import { BASE_CUSTOMERS_PATH } from '../../../../routes/constants';

import { noop } from 'ui-components/default-props/noop';

import style from './customers-left-nav-container.module.less';

const messages = defineMessages({
  searchValue: {
    description: 'customersPage.search-value',
    defaultMessage: 'Search Customers...',
    id: '8Aaimy',
  },
  navLabelValue: {
    description: 'customersPage.nav.customers',
    defaultMessage: 'Customers',
    id: 'KPvB3X',
  },
});

const buildTagProps = () => ({
  to: BASE_CUSTOMERS_PATH,
});

const navItems = [
  {
    id: 'list',
    selected: true,
    label: <FormattedMessage {...messages.navLabelValue} />,
  },
];

const defaultFormDataSelector = createSelector(
  (searchData) => searchData,
  (searchData) => ({
    searchTerm: get(searchData, 'searchTerm', ''),
  }),
);

const CustomersLeftNav = () => {
  const dispatch = useDispatch();
  const searchPerformed = useSelector(Global.selectCustomersNavSearchPerformed);
  const searchData = useSelector(Global.selectCustomersNavSearchData);

  useEffect(() => {
    return () => dispatch(NavActions.clearSearchInput());
  }, [dispatch]);

  const onSearch = useCallback(
    (searchObj) => {
      dispatch(NavActions.customersSearch(searchObj));
      dispatch(NavActions.setSearchPerformed(true));
    },
    [dispatch],
  );

  const onRefreshCustomers = useCallback(() => {
    dispatch(requestGetCustomers());
    dispatch(NavActions.setSearchPerformed(false));
  }, [dispatch]);

  const onItemSelected = useCallback(() => dispatch(NavActions.customersGridRefresh()), [dispatch]);
  const onClearSearchInput = useCallback(() => dispatch(NavActions.clearSearchInput()), [dispatch]);
  const onCustomerSearchTermChange = useCallback((searchTerm) => dispatch(NavActions.customerSearchTermChange(searchTerm)), [dispatch]);

  return (
    <div className={style['tree-nav-container']}>
      <SearchForm
        clearSearchInput={onClearSearchInput}
        defaultFormData={defaultFormDataSelector(searchData)}
        getSearchTermCount={noop}
        handleSearchInputChange={onCustomerSearchTermChange}
        isHighlighted={searchPerformed}
        onSearch={onSearch}
        placeholder={messages.searchValue}
        refreshGridData={onRefreshCustomers}
      />
      <div className={style['tree-and-batches']}>
        <TreeNav buildTagProps={buildTagProps} isHighlighted={searchPerformed} items={navItems} onItemSelected={onItemSelected} />
      </div>
    </div>
  );
};

export { CustomersLeftNav };
